import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckIcon from "@mui/icons-material/Check";
import globalState from "./globalState";
import {  useLocation } from "react-router-dom";
import { useTheme } from "../style/theme";


const ListFilesFoldersOrganizer = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const { mode } = useTheme();

  var isRecentScreen = location.pathname === '/recent'
  var isHomeScreen = location.pathname === '/' || location.pathname === '/home'

  const [listFileFolderOrganizeSelectedOption, setListFileFolderOrganizeSelectedOption] = useState(
    globalState.getState("listFileFolderOrganizeSelectedOption")
  );

  useEffect(() => {
    const unsubscribe = globalState.subscribe(({ key, value }) => {
      if (key === "listFileFolderOrganizeSelectedOption") {
        setListFileFolderOrganizeSelectedOption(value);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (option) => {
    globalState.setState("listFileFolderOrganizeSelectedOption", option)
    handleMenuClose();
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

      }}
    >
      <Typography></Typography>
      <IconButton onClick={handleMenuOpen}
        sx={{
          color: "#A5A5A5",
        }}

      >
        {!isHomeScreen && !isRecentScreen &&
          <MoreVertIcon sx={{ fontSize: 24,  }} />

        }
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            // backgroundColor: "rgb(3, 3, 3)",
            // color: "#fff",
            borderRadius: "8px",
            minWidth: "250px",
            padding: "4px 0",
            boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",  
            background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",

          },
        }}
      >
        <Typography
          sx={{
            px: 2,
            py: 1,
            fontSize: "12px",
            // color: "rgba(255, 255, 255, 0.6)",
            fontWeight: 500,
          }}
        >
          Show Folders
        </Typography>

        <MenuItem onClick={() => handleSelection("On top")}>
          <ListItemIcon>
            {listFileFolderOrganizeSelectedOption === "On top" && <CheckIcon sx={{ fontSize: "18px",}} />}
          </ListItemIcon>
          <ListItemText primary="On top" />
        </MenuItem>

        <MenuItem onClick={() => handleSelection("Mixed with files")}>
          <ListItemIcon>
            {listFileFolderOrganizeSelectedOption === "Mixed with files" && <CheckIcon sx={{ fontSize: "18px",  }} />}
          </ListItemIcon>
          <ListItemText primary="Mixed with files" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ListFilesFoldersOrganizer;
